<template>
    <div>
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" style="margin-top:10px" label-position="right"
                 label-width="140px">
            <h3>基础信息</h3>
            <el-row :gutter="8">
                <el-col :span="8">
                    <el-form-item label="企业名称" prop="enterpriseName">
                        <el-tooltip placement="top" effect="light">
                            <div slot="content">{{dataForm.enterpriseName}}</div>
                            <el-input disabled size="small" v-model="dataForm.enterpriseName"/>
                        </el-tooltip>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="企业简称" prop="venderAbbreviation">
                        <el-tooltip placement="top" effect="light">
                            <div slot="content">{{dataForm.venderAbbreviation}}</div>
                            <el-input disabled size="small" v-model="dataForm.venderAbbreviation"/>
                        </el-tooltip>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="企业性质" prop="enterpriseNature">
                        <el-select disabled size="small" v-model="dataForm.enterpriseNature" style="width: 100%;">
                            <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="8">
                <el-col :span="8">
                    <el-form-item label="注册地址" prop="address">
                        <el-tooltip placement="top" effect="light">
                            <div slot="content">{{dataForm.address}}</div>
                            <el-input disabled size="small" v-model="dataForm.address"/>
                        </el-tooltip>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="供应商代码" prop="venderCode">
                        <div slot="content">{{dataForm.venderCode}}</div>
                        <el-input size="small" v-model="dataForm.venderCode" disabled/>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="社会信用代码" prop="creditCode">
                        <el-tooltip placement="top" effect="light">
                            <div slot="content">{{dataForm.creditCode}}</div>
                            <el-input disabled size="small" v-model="dataForm.creditCode"></el-input>
                        </el-tooltip>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="8">
                <el-col :span="8">
                    <el-form-item label="邮政编码" prop="postCode">
                        <el-input disabled size="small" v-model="dataForm.postCode"/>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="法人代表" prop="legalPerson">
                        <el-input disabled size="small" v-model="dataForm.legalPerson"/>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="供应商关系" prop="venderType">
                        <el-select disabled size="small" v-model="dataForm.venderType" style="width: 100%;">
                            <el-option
                                    v-for="item in options2"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="8">
                <el-col :span="8">
                    <el-form-item label="传真" prop="fax">
                        <el-input disabled size="small" v-model="dataForm.fax"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="电话" prop="tel">
                        <el-input disabled size="small" v-model="dataForm.tel"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="网址" prop="website">
                        <el-input disabled size="small" v-model="dataForm.website"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="8">
                <el-col :span="8">
                    <el-form-item label="省" prop="province">
                        <el-select disabled size="small" v-model="dataForm.province" filterable clearable placeholder="请选择省份" style="width: 100%;">
                            <el-option v-for="item in provinceOptions" :key="item.code" :label="item.name" :value="item.code">
                            </el-option>
                          </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="市" prop="city">
                        <el-input disabled size="small" v-model="dataForm.city"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="企业股权情况" prop="venturePartner">
                        <el-input disabled size="small" v-model="dataForm.venturePartner"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="8">
                <el-col :span="8">
                    <el-form-item label="供应商经验" prop="venderExpierence">
                        <el-input disabled size="small" v-model="dataForm.venderExpierence"></el-input>
                    </el-form-item>
                </el-col>
              <el-col :span="8">
                <el-form-item label="营业执照到期日期" prop="blEndDate">
                  <el-date-picker disabled v-model="dataForm.blEndDate"  type="date" value-format="yyyy-MM-dd" placeholder="请选择营业执照到期日期">
                  </el-date-picker>
                  <span style="margin-left: 12px;">长期</span>
                  <el-checkbox disabled :value="blLongTermChecked" style="margin-left: 4px;"></el-checkbox>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="16949/9000体系证书到期日期" prop="scEndDate">
                  <el-date-picker disabled v-model="dataForm.scEndDate"  type="date" value-format="yyyy-MM-dd" placeholder="请选择16949/9000体系证书到期日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <h3>电子银行承兑汇票业务信息</h3>
            <el-row :gutter="8">
                <el-col :span="10">
                    <el-form-item label="银行名称" prop="bankName">
                        <el-input :disabled="true" size="small" v-model="dataForm.bankName"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="开户行行号" prop="swiftCode">
                        <el-input :disabled="true" size="small" v-model="dataForm.swiftCode"/>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="开户行地址" prop="bankAddress">
                        <el-tooltip placement="top" effect="light">
                            <div slot="content">{{dataForm.bankAddress}}</div>
                            <el-input :disabled="true" size="small" v-model="dataForm.bankAddress"/>
                        </el-tooltip>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="8">
                <el-col :span="8">
                    <el-form-item label="账户持有人" prop="accountName">
                        <el-tooltip placement="top" effect="light">
                            <div slot="content">{{dataForm.accountName}}</div>
                            <el-input :disabled="true" size="small" v-model="dataForm.accountName"/>
                        </el-tooltip>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="开户账号" prop="accountNum">
                        <el-input :disabled="true" size="small" v-model="dataForm.accountNum"/>
                    </el-form-item>
                </el-col>
                <!-- <el-col :span="8">
                    <el-form-item label="税务登记号" prop="taxNum">
                        <el-input :disabled="true" size="small" v-model="dataForm.taxNum"/>
                    </el-form-item>
                </el-col> -->
            </el-row>
            <h3>供应商情况简介</h3>
            <el-row :gutter="8">
                <el-col>
                    <el-form-item label="情况简介" prop="venderIntroduce">
                        <el-input type="textarea" maxlength="500" :rows="3"
                                  :disabled="true"
                                  v-model="dataForm.venderIntroduce"/>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
              <el-col :span="24" style="color:white;">. </el-col>
              <el-col :span="24" style="color:white;">. </el-col>
              <el-col :span="24" style="color:white;">. </el-col>
              <el-col :span="24" style="color:white;">. </el-col>
              <el-col :span="24" style="color:white;">. </el-col>
              <el-col :span="24" style="color:white;">. </el-col>
              <el-col :span="24" style="color:white;">. </el-col>
              <el-col :span="24" style="color:white;">. </el-col>
              <el-col :span="24" style="color:white;">. </el-col>
              <el-col :span="24" style="color:white;">. </el-col>
            </el-row>
        </el-form>
    </div>
</template>

<script>
    import {getSupplieInfo1} from '@/controller/supplier'
    import {getBankList,getProvinceList} from '@/controller/systemData'

    export default {
        data() {
            return {
                bankList: [],
                pageIndex: 1,
                pageSize: 10,
                dataList: [],
                dataRule: {
                    enterpriseName: [{required: true, message: '不能为空', trigger: 'blur'}],
                    venderAbbreviation: [{required: true, message: '不能为空', trigger: 'blur'}],
                    enterpriseNature: [{required: true, message: '不能为空', trigger: 'blur'}],
                    address: [{required: true, message: '不能为空', trigger: 'blur'}],
                    creditCode: [{required: true, message: '不能为空', trigger: 'blur'}],
                    postCode: [{required: true, message: '不能为空', trigger: 'blur'}],
                    legalPerson: [{required: true, message: '不能为空', trigger: 'blur'}],
                    accountName: [{required: true, message: '不能为空', trigger: 'blur'}],
                    accountNum: [{required: true, message: '不能为空', trigger: 'blur'}],
                    bankAddress: [{required: true, message: '不能为空', trigger: 'blur'}],
                    swiftCode: [{required: true, message: '不能为空', trigger: 'blur'}],
                    venderIntroduce: [{required: true, message: '不能为空', trigger: 'blur'}],
                    province: [{required: true, message: '不能为空', trigger: 'blur'}],
                    city: [{required: true, message: '不能为空', trigger: 'blur'}],
                    blEndDate: [{required: true, message: '不能为空', trigger: 'blur'}],
                    scEndDate: [{required: true, message: '不能为空', trigger: 'blur'}],

                },
                options: [
                    {label: '私有控股', value: '0'},
                    {label: '国有（集体）控股', value: '1'},
                    {label: '中外合资企业', value: '2'},
                    {label: '外商独资企业', value: '3'}
                ],
                options2: [
                    {label: '公司所属供应商', value: '0'},
                    {label: '股东供应商', value: '1'},
                    {label: '一般供应商', value: '2'}
                ],
                dataForm: {
                    venderAbbreviation:'',
                    venderExpierence:'',
                    enterpriseName: '',
                    venderCode: '',
                    venderType: '',
                    basicInfoId: '',
                    enterpriseNature: '',
                    venturePartner: '',
                    address: '',
                    creditCode: '',
                    postCode: '',
                    legalPerson: '',
                    taxNum: '',
                    bankName: '',
                    fax: '',
                    accountName: '',
                    accountNum: '',
                    bankAddress: '',
                    paynum: '',
                    venderIntroduce: '',
                    swiftCode: '',
                    venderSource: '',
                    workflowId: '',
                    city:'',
                    province:'',
                    tel:'',
                    website:'',
                    blEndDate:'',
                    scEndDate:'',
                    blLongTerm: null,
                },
                venderInviteFid: '',
                user: '',
                // 省
                provinceOptions:[],
            }
        },
        props: {
            superId: Number
        },
        mounted() {
            this.getList()
        },
        watch: {
            venderInviteFid() {
                this.getDataList()
            }
        },
        computed: {
            blLongTermChecked() {
                return this.dataForm.blLongTerm == 1
            }
        },
        methods: {
            getList() {
                // listInvitedForSupplier().then(data => {
                //     this.dataForm.workflowId = data.body.records[0].workflowId
                //     this.dataForm.enterpriseName = data.body.records[0].venderName
                //     this.dataForm.venderSource = data.body.records[0].venderSource
                //     this.dataForm.venderCode = data.body.records[0].venderCode
                //     this.dataForm.address = data.body.records[0].venderAdd
                //     this.venderInviteFid = data.body.records[0].id
                //     this.createdBy = data.body.records[0].createBy//TODO 采购员
                //     // this.setId()
                // })
            },

            // 根据邀请id从基本信息表查询该公司信息
            getDataList(superId) {
                // 银行列表
                //this.getBankList()
                // 省份列表
                this.getProvinceList()
                var v;
                if(superId){
                    v = superId
                }else{
                    v = this.superId
                }
                getSupplieInfo1({
                    'id': v
                }).then(data => {
                    if (data && data.code === '00') {
                        if (data.body) {
                            this.dataForm.basicInfoId = data.body.id
                            this.dataForm.enterpriseName = data.body.enterpriseName
                            this.dataForm.enterpriseNature = data.body.enterpriseNature
                            this.dataForm.venturePartner = data.body.venturePartner
                            this.dataForm.address = data.body.address
                            this.dataForm.creditCode = data.body.creditCode
                            this.dataForm.postCode = data.body.postCode
                            this.dataForm.legalPerson = data.body.legalPerson
                            this.dataForm.venderType = data.body.venderType
                            this.dataForm.taxNum = data.body.taxNum
                            this.dataForm.bankName = data.body.bankName
                            this.dataForm.fax = data.body.fax
                            this.dataForm.accountName = data.body.accountName
                            this.dataForm.accountNum = data.body.accountNum
                            this.dataForm.bankAddress = data.body.bankAddress
                            this.dataForm.paynum = data.body.paynum
                            this.dataForm.venderIntroduce = data.body.venderIntroduce
                            this.dataForm.swiftCode = data.body.swiftCode
                            this.dataForm.city = data.body.city
                            this.dataForm.province = data.body.province,
                            this.dataForm.venderCode = data.body.venderCode,
                            this.dataForm.tel = data.body.tel,
                            this.dataForm.website = data.body.website,
                            this.dataForm.venderAbbreviation = data.body.venderAbbreviation
                            this.dataForm.venderExpierence = data.body.venderExpierence
                            this.dataForm.scEndDate = data.body.scEndDate
                            this.dataForm.blEndDate = data.body.blEndDate
                            this.$set(this.dataForm, 'blLongTerm', data.body.blLongTerm)
                        }
                    }
                    this.dataListLoading = false
                    this.setId()
                })
            },
            //保存数据到basicinfo表
            dataFormSubmit() {
                this.$refs['dataForm'].validate((valid) => {
                    if (valid) {
                        // const me = this
                        // saveSupplierBasicInfo({
                        //     'id': this.dataForm.basicInfoId || undefined,
                        //     'enterpriseNature': this.dataForm.enterpriseNature,
                        //     'venturePartner': this.dataForm.venturePartner,
                        //     'address': this.dataForm.address,
                        //     'creditCode': this.dataForm.creditCode,
                        //     'postCode': this.dataForm.postCode,
                        //     'legalPerson': this.dataForm.legalPerson,
                        //     'taxNum': this.dataForm.taxNum,
                        //     'bankName': this.dataForm.bankName,
                        //     'fax': this.dataForm.fax,
                        //     'accountName': this.dataForm.accountName,
                        //     'accountNum': this.dataForm.accountNum,
                        //     'bankAddress': this.dataForm.bankAddress,
                        //     'paynum': this.dataForm.paynum,
                        //     'venderIntroduce': this.dataForm.venderIntroduce,
                        //     'venderInviteFid': this.venderInviteFid,
                        //     'enterpriseName': this.dataForm.enterpriseName,
                        //     'venderCode': this.dataForm.venderCode,
                        //     'swiftCode': this.dataForm.swiftCode,
                        //     'venderType': this.dataForm.venderType
                        // }).then(data => {
                        //     if (data && data.code === '00') {
                        //         this.$message({
                        //             message: '保存成功',
                        //             type: 'success'
                        //         })
                        //         this.showUsers = false
                        //         this.dataForm.basicInfoId = data.body
                        //         this.setId()
                        //     } else {
                        //         this.$message.error(data.msg)
                        //     }
                        // })
                    }
                })
            },

            // 查询银行
            getBankList() {
                getBankList({
                    bankCode: "",
                    bankName: "",
                }).then(data => {
                    if (data && data.code === '00') {
                        this.bankList = data.body;
                    }
                });
            },

            getProvinceList(){
                getProvinceList({
                    code: "",
                    name: "",
                }).then(data => {
                    if (data && data.code === '00') {
                        this.provinceOptions = data.body;
                    }
                });
            },

            // 银行
            getBankName(val) {
                const bank = this.bankList.find(bank => bank.bankCode === val)
                return bank ? bank.bankName : ''
            },

            setId() {
                this.$emit('getId', this.dataForm.basicInfoId, this.venderInviteFid, this.dataForm.basicInfoId, this.createdBy, this.dataForm.workflowId)
            }
        }
    }
</script>
